import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  select (event) {
    const selectedTab = event.currentTarget
    const metricId = selectedTab.dataset.metricId

    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.metricId === metricId
      tab.classList.toggle('is-active', active)
      tab.setAttribute('aria-selected', active.toString())
    })

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.metricId !== metricId
    })
  }
}
